
export default function Footer() {
  const footerLinks = {
    Marketplace: ['Browse Agencies', 'Featured Listings', 'Recently Added', 'Success Stories'],
    Incubator: ['Apply Now', 'Program Details', 'Portfolio Companies', 'Resources'],
    Company: ['About Us', 'Team', 'Careers', 'Press'],
    Support: ['Help Center', 'Contact', 'Documentation', 'API']
  };

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-20">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="text-2xl font-light text-white tracking-tight mb-6">
              AI<span className="font-semibold">Exchange</span>
            </div>
            <p className="text-gray-400 font-light leading-relaxed mb-8 max-w-sm">
              The premier marketplace for AI agencies, service companies, and automation businesses.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all duration-200">
                <i className="ri-twitter-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all duration-200">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all duration-200">
                <i className="ri-github-line"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-white font-medium mb-6 text-sm uppercase tracking-wider">
                {category}
              </h3>
              <ul className="space-y-4">
                {links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200 text-sm font-light">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter */}
        <div className="border-t border-white/10 pt-16 mb-16">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-2xl font-light text-white mb-4">
              Stay updated on AI opportunities
            </h3>
            <p className="text-gray-400 mb-8 font-light">
              Get notified about new AI agencies, market insights, and exclusive deals.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-transparent backdrop-blur-sm"
              />
              <button className="px-8 py-4 bg-white text-black rounded-xl font-medium hover:bg-gray-100 transition-colors duration-200 whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-500 text-sm mb-4 md:mb-0">
            © 2024 AIExchange. All rights reserved.
          </div>
          <div className="flex items-center space-x-8">
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors duration-200">
              Terms of Service
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors duration-200">
              NDA Agreement
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
